import React, { useEffect, useRef, useState } from 'react';
import { promptImageUrl, readImageFile } from '../../utils/imageUpload';
import './editable.css';

export default function VideoEditModal({ video, title = 'Edit video', onClose, onSaveUrl, onSaveThumbnail, onRemove }) {
  const [url, setUrl] = useState(video.url);
  const thumbInputRef = useRef(null);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);

  const handleThumbnailFile = async (file) => {
    if (!file) return;
    try {
      const dataUrl = await readImageFile(file);
      onSaveThumbnail(dataUrl);
    } catch (error) {
      window.alert(error.message);
    }
  };

  return (
    <div className="video-edit-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="video-edit-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="video-edit-modal-title"
      >
        <button type="button" className="video-edit-modal-close" onClick={onClose} aria-label="Close">
          &times;
        </button>
        <h3 id="video-edit-modal-title" className="video-edit-modal-title">
          {title}
        </h3>
        <div className="video-edit-modal-preview">
          <img src={video.thumbnail} alt="" />
        </div>
        <label className="video-edit-modal-label" htmlFor="video-edit-url">
          YouTube URL
        </label>
        <input
          id="video-edit-url"
          type="url"
          className="video-edit-modal-input"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://www.youtube.com/..."
        />
        <div className="video-edit-modal-actions">
          <button
            type="button"
            className="video-edit-modal-btn"
            onClick={() => {
              if (url.trim()) onSaveUrl(url.trim());
            }}
          >
            Save URL
          </button>
          <button type="button" className="video-edit-modal-btn" onClick={() => thumbInputRef.current?.click()}>
            Upload thumbnail
          </button>
          <button
            type="button"
            className="video-edit-modal-btn"
            onClick={() => {
              const thumbUrl = promptImageUrl();
              if (thumbUrl) onSaveThumbnail(thumbUrl);
            }}
          >
            Thumbnail URL
          </button>
          {onRemove && (
            <button
              type="button"
              className="video-edit-modal-btn video-edit-modal-btn--danger"
              onClick={() => {
                if (window.confirm('Remove this video?')) onRemove();
              }}
            >
              Remove
            </button>
          )}
        </div>
        <input
          ref={thumbInputRef}
          type="file"
          accept="image/*"
          className="editable-image-input"
          onChange={(e) => {
            handleThumbnailFile(e.target.files?.[0]);
            e.target.value = '';
          }}
        />
      </div>
    </div>
  );
}
